import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import * as serviceWorkerRegistration from "@/serviceWorkerRegistration";
import { toast } from "sonner";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Boot the PWA service worker AFTER the React tree mounts so first paint isn't blocked.
serviceWorkerRegistration.register({
    onUpdate: (reg) => {
        // A new SW is waiting — nudge the user to refresh.
        toast(
            "A new version of Fits Me is ready — refresh to load it.",
            {
                action: {
                    label: "Refresh",
                    onClick: () => {
                        if (reg.waiting) reg.waiting.postMessage({ type: "SKIP_WAITING" });
                        window.location.reload();
                    },
                },
                duration: 12000,
            },
        );
    },
});
